import { TimePicker } from "antd";
import plus from "../../../../assets/admin/plus.svg";
import { MdDelete } from "react-icons/md";
import dayjs from "dayjs";

const MenuTimeSlotAdd = (props) => {
  const {
    days,
    activeDay,
    setActiveDay,
    timeSlots,
    handleAddTimeSlot,
    handleTimeSlotChange,
    statusValue,
    handleRemoveTimeSlot,
  } = props;

  return (
    <div className="mb-4">
      {statusValue === "active" && (
        <>
          <h2 className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] pt-4">
            Time Slot:
          </h2>
          <div className="border mt-6 border-[#777777] rounded-[14px] p-3">
            <div className="grid xl:grid-cols-7 md:grid-cols-3 grid:cols-2 gap-3 mt-10">
              {days.map((day) => (
                <div key={day} className="flex items-center justify-start flex-col gap-2">
                  <span
                    onClick={() => {
                      setActiveDay(day)
                      if (!Object.keys(timeSlots).includes(day)) {
                        handleAddTimeSlot(day)
                      }
                    }}
                    className={`cursor-pointer py-[10px]  text-[20px] leading-[20px] font-medium rounded-3xl block w-full text-center ${activeDay === day ? "bg-[#8b2433] text-white" : (Object.keys(timeSlots).includes(day)) ? "bg-[#8b243385] text-white" : "text-[#000]"
                      }`}
                  >
                    {day}
                  </span>
                </div>
              ))}
            </div>
            {activeDay && (
              <div className="flex flex-col border mt-5 p-5 items-center rounded-[14px]">
                <div className="text-center flex items-center justify-center gap-[15px] w-full flex-col">
                  {timeSlots[activeDay]?.map((slot, index) => (
                    <div key={index} className="mt-2 flex gap-2 items-center justify-center">
                      <div className="flex items-center gap-3 justify-between  max-w-[250px]">
                        <TimePicker
                          onChange={(newValue) => {
                            if (newValue) {
                              handleTimeSlotChange(
                                activeDay,
                                index,
                                "start_time",
                                newValue.format("HH:mm")
                              );
                            }
                          }}
                          value={slot.start_time ? dayjs(slot.start_time, "HH:mm") : dayjs("00:00", 'HH:mm')}
                          format="HH:mm"
                          className="custom-timepicker"
                          // changeOnScroll
                          needConfirm
                        />
                        <TimePicker
                          onChange={(newValue) => {
                            if (newValue) {
                              handleTimeSlotChange(
                                activeDay,
                                index,
                                "end_time",
                                newValue.format("HH:mm")
                              );
                            }
                          }}
                          value={slot.end_time ? dayjs(slot.end_time, "HH:mm") : dayjs("23:59", 'HH:mm')}
                          format="HH:mm"
                          className="custom-timepicker"
                          // changeOnScroll
                          needConfirm
                        />
                      </div>
                      <button
                        onClick={() => handleRemoveTimeSlot(activeDay, index)}
                        className="w-[28px] h-[30px] rounded flex items-center  justify-center"
                      >
                        <MdDelete color="#8b2433" className="text-xl" />
                      </button>
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => handleAddTimeSlot(activeDay)}
                  className="bg-[#8b2433] text-white mt-5 w-[60px] h-[30px] rounded flex items-center  justify-center"
                >
                  <img
                    src={plus}
                    alt="Add"
                    className="w-3 h-10 filter S-0 items-center transition duration-300 ease-in-out invert-0"
                  />
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default MenuTimeSlotAdd;
